// FearGreedWidget/FearGreedEngine.js
// Engine Pattern (rk=f03ae8b6) — extends EngineCleanupBase, singleton export.
// REST fetch is triggered explicitly by PageContent (fetch()) for the initial
// 31-day history, gateway pushes new values via SignalR from there on
// (see PageContentSRHandlers) — no polling timer.
import EngineCleanupBase from '../../../services/engines/EngineCleanupBase';
import ComponentNotifier from '../../../services/wss/ComponentNotifier';
import fearGreedCache from './FearGreedCache';
import fearGreedFetcher from './FearGreedFetcher';
import FearGreedHistoryCalculator from './FearGreedHistoryCalculator';

const _name = 'FearGreedEngine';

class FearGreedEngine extends EngineCleanupBase {
    bootup = () => {
        this.initialize(_name);
    };

    /**
     * SignalR handler — called from PageContentSRHandlers on new pushed values.
     * NOTE: inline event handler — if engine grows, move to _handlers pattern (see Development.Patterns).
     * @param {{rk:string,value:number,class:string,ems:number}} item
     */
    onFearIndexReceived = (item) => {
        try {
            fearGreedCache.addOrUpdate([item]);
            this._notify();
        } catch (error) {
            this.logError('onFearIndexReceived', error.message);
        }
    };

    /**
     * @returns {object|null} current + history snapshot derived from the cached raw items
     */
    getState = () => FearGreedHistoryCalculator.buildState(fearGreedCache.getAll());

    /**
     * @returns {object[]} cached history, oldest first, for the chart
     */
    getHistory = () => FearGreedHistoryCalculator.sortAscending(fearGreedCache.getAll());

    /**
     * Fetches the initial 31-day history via REST. Called once from PageContent
     * alongside the other engines' fetch/fetchAll calls.
     * @returns {Promise<void>}
     */
    fetch = async () => {
        try {
            const items = await fearGreedFetcher.fetch();
            if (!items.length) return;

            fearGreedCache.addOrUpdate(items);
            this._notify();
        } catch (error) {
            this.logError('fetch', error.message);
        }
    };

    _notify = () => {
        ComponentNotifier.notify(_name, 'dataChanged', { state: this.getState() });
    };
}

const fearGreedEngine = new FearGreedEngine();
export default fearGreedEngine;
